App.controller('LifeWithPaymentsListCtrl', ['$scope', '$stateParams', '$sce', '$state', '$http', '$mdDialog', 'Configurator', 'profileService', '$timeout', '$rootScope', 'lifeInsuranceWithPaymentsService', 'moment', 'wireTransferService', 'popUpService', '$filter', 'Blob', 'FileSaver', function ($scope, $stateParams, $sce, $state, $http, $mdDialog, Configurator, profileService, $timeout, $rootScope, lifeInsuranceWithPaymentsService, moment, wireTransferService, popUpService, $filter, Blob, FileSaver) {
    $scope.stateParams = $stateParams;

    $scope.page = 'mypackage';
    $scope.$emit('page', $scope.page);

    $scope.step = `Ubezpieczenie na życie (${Configurator.lifeInsuranceWithPayments.insurer.toUpperCase()})`;
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.home.dashboard';
    $scope.$emit('link', $scope.link);

    $scope.isMainUser = true;

    function checkIfUserHasActiveDeclaration() {
        if ($scope.userData && $scope.package) {
            if ($scope.package.status === 'ENTERED') {
                $scope.status = 'Oczekiwanie na wpłatę';
            } else if ($scope.package.status === 'READY') {
                $scope.status = 'Pakiet opłacony – aktywacja od ' + $scope.package.proposedDate;
            } else if ($scope.package.status === 'ACTIVE') {
                $scope.status = 'Pakiet aktywny od ' + moment(new Date($scope.package.activeDate)).format('YYYY-MM-DD');
            } else if ($scope.package.status === 'WITHDRAWN') {
                $scope.status = 'Zakończenie pakietu z dniem ' + moment(new Date($scope.package.endDateBasedOnWithdrawalDate)).format('YYYY-MM-DD');
            } else if ($scope.package.status === 'ENDED') {
                $scope.status = 'Pakiet zakończony z dniem ' + moment(new Date($scope.package.endedDate)).format('YYYY-MM-DD');
            } else {
                $scope.status = 'Pakiet czeka na aktywację';
            }
            if ($scope.package.payedToDate) {
                $scope.payedToDate = moment(new Date($scope.package.payedToDate)).format('YYYY-MM-DD');
            }

            $scope.userData.hasActiveDeclaration = $scope.package.status === 'ACTIVE';
            $scope.userData.isAfterSixMonth = false;
            if ($scope.userData.hasActiveDeclaration && $scope.package.activeDate) {
                var _activeDate = new Date($scope.package.activeDate);
                _activeDate.setMonth(_activeDate.getMonth() + 5);

                var now = new Date();
                if (now.getTime() >= _activeDate.getTime()) {
                    $scope.userData.isAfterSixMonth = true;
                }
            }
        }
    }

    $scope.package = null;
    lifeInsuranceWithPaymentsService.last().then(function (data) {
        if (data.status === 200) {
            if (!data.data || !Object.keys(data.data).length) {
                $state.go('root.life.variant');
                return;
            }
            $scope.package = data.data.main;

            var totalPrice = 0;
            $scope.subpackages = []
            angular.forEach(data.data.subDeclarations, function (declaration) {
                $scope.subpackages.push({
                    user: declaration.person.firstName + " " + declaration.person.lastName,
                    packages: declaration.packages
                });
                totalPrice += declaration.summaryPrice;
            });

            let names = [];
            let policyNumbers = [];
            $scope.package.lifeInsurances.forEach(function (lifeInsurance) {
                totalPrice += lifeInsurance.price;
                names.push(lifeInsurance.name);
                if (lifeInsurance.type === 'BASE') {
                    policyNumbers.push('Numer polisy P PLUS: ' + lifeInsurance.policyNumber);
                } else if (lifeInsurance.type === 'ACCIDENT') {
                    policyNumbers.push('Numer polisy WRW: ' + lifeInsurance.policyNumber);
                }
            });
            $scope.package.benefit = {
                names: names,
                policyNumbers: policyNumbers,
                summaryPrice: totalPrice,
            };
            checkIfUserHasActiveDeclaration();
        }
    });
    profileService.dataUser().then(function (data) {
        $scope.userData = data.data;
        $scope.isMainUser = !$scope.userData.mainUserId;
        checkIfUserHasActiveDeclaration();
    });

    $scope.bankAccountNumber = null;
    profileService.getBankAccountNumber('LIFE_INSURANCE').then(function (success) {
        if (success.data) {
            $scope.bankAccountNumber = success.data['accountNumber'];
            profileService.getBankAccountBalance('HEALTH_INSURANCE').then(function (success) {
                if (success.status === 200 && success.data) {
                    let balance = success.data.balance;
                    if (balance) {
                        $scope.paymentsBalance = $filter('floatCurrencyFormatter')(balance);
                    }
                }
            });
        }
    });

    $scope.current = 0;
    $scope.numberOfPages = 1;
    $scope.searchString = '';

    loadActivities($scope.current);

    $scope.payments = [];
    $scope.paymentsCurrent = 0;
    $scope.paymentsNumberOfPages = 1;
    $scope.paymentsPageSize = 10;

    loadPayments($scope.current);

    function loadActivities(page) {
        var criteria = {
            pageNumber: page,
            pageSize: 10,
            searchString: $scope.searchString
        }
        lifeInsuranceWithPaymentsService.dataList(criteria).then(function (data) {
            if (data.status === 200) {
                // angular.forEach(data.data.data, function (single) {
                //     single.numberOfRelatives = (single.partner ? 1 : 0) + single.children.length;
                // });
                $scope.activities = data.data.data;
                $scope.numberOfPages = data.data.pages;
                // $scope.buildScroll();
                // console.log($scope.activities);
            }
        });
    }

    function loadPayments(page) {
        var params = {
            pageNumber: page,
            pageSize: $scope.paymentsPageSize,
            insuranceProject: 'LIFE_INSURANCE'
        }
        wireTransferService.getPayments(params).then(function (data) {
            if (data.status === 200) {
                $scope.payments = data.data.data;
                $scope.paymentsNumberOfPages = data.data.pages;
            }
        })
    }

    $scope.search = function () {
        loadActivities(0);
    };

    $scope.pageChanged = function (page) {
        loadActivities(page);
        $scope.current = page;
    };

    $scope.paymentsPageChanged = function (page) {
        loadPayments(page);
        $scope.paymentsCurrent = page;
    };

    function PopUpInfoCtrl($scope, $mdDialog, locals, config) {
        $scope.locals = locals;
        $scope.config = config;

        $scope.hide = function () {
            $mdDialog.hide();
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        $scope.confirm = function () {
            $mdDialog.hide($scope.locals);
        };
    }

    PopUpInfoCtrl.$inject = ['$scope', '$mdDialog', 'locals', 'config'];
    $scope.showPopUp = function (ev, head, content, confirmText, cancelText) {
        return $mdDialog.show({
            controller: PopUpInfoCtrl,
            templateUrl: Configurator.CORE.TEMPLATES_DIR + 'PopUp/info-big.html',
            targetEvent: ev,
            clickOutsideToClose: false,
            locals: {
                head: head,
                content: content,
                button: {
                    text: confirmText,
                    target: null
                }
            },
            config: {
                cancelButton: cancelText
            }
        })
    }
    $scope.downloadCertificate = function (event, declaration) {
        var el = $(event.currentTarget);
        if (el.hasClass('disabled')) {
            return 0;
        } else {
            $(event.currentTarget).addClass('disabled');
        }
        lifeInsuranceWithPaymentsService.downloadCertificate(declaration.uuid).then(
            function (success) {
                if (success.status === 200) {
                    let blob = new Blob([success.data], {type: "application/pdf"});
                    let filename = $filter('getFileNameFromContentDisposition')(success.headers('Content-Disposition'));
                    FileSaver.saveAs(blob, filename ? filename : 'certyfikat.pdf');
                }
            }
        ).finally(function () {
            $timeout(function () {
                $(event.currentTarget).removeClass('disabled');
            }, 1000);
        });
    }

    $scope.downloadDeclaration = function (event, declaration) {
        var el = $(event.currentTarget);
        if (el.hasClass('disabled')) {
            return 0;
        } else {
            $(event.currentTarget).addClass('disabled');
        }
        lifeInsuranceWithPaymentsService.downloadDeclaration(declaration.uuid).then(
            function (success) {
                if (success.status === 200) {
                    let blob = new Blob([success.data], {type: "application/pdf"});
                    let filename = $filter('getFileNameFromContentDisposition')(success.headers('Content-Disposition'));
                    FileSaver.saveAs(blob, filename ? filename : 'certyfikat.pdf');
                }
            }
        ).finally(function () {
            $timeout(function () {
                $(event.currentTarget).removeClass('disabled');
            }, 1000);
        });
    }

    $scope.withdraw = function (declaration) {
        var today = new Date();
        var endDateBasedOnWithdrawalDate;
        if (today.getDate() <= 20) {
            endDateBasedOnWithdrawalDate = moment().add(1, 'month').startOf('month');
        } else {
            endDateBasedOnWithdrawalDate = moment().add(2, 'month').startOf('month');
        }
        endDateBasedOnWithdrawalDate = endDateBasedOnWithdrawalDate.format('DD-MM-YYYY')
        let confirmationMessage = 'Rezygnacja z ubezpieczenia oznacza zakończenie świadczenia ochrony z dniem ' + endDateBasedOnWithdrawalDate + '.<br/>';
        if ($scope.subpackages.length > 0 && declaration.type === 'MAIN_USER') {
            confirmationMessage += 'Rezygnacja Głównego Ubezpieczonego oznacza również wystąpienie z ubezpieczenia wszystkich zgłoszonych członków rodziny.<br/>';
        }
        confirmationMessage += 'Potwierdź chęć rezygnacji z ubezpieczenia na życie.';
        $scope.showPopUp('', 'UWAGA', confirmationMessage, 'Potwierdzam rezygnację', 'Cofnij')
            .then(function () {
                withdrawDeclaration(declaration);
            });
    }

    function withdrawDeclaration(declaration) {
        function withdrawError() {
            popUpService.showPopUp({content: 'Niestety nie udało się zrezygnować z deklaracji, skontaktuj się z administratorem.'});
        }

        lifeInsuranceWithPaymentsService.withdrawDeclaration(declaration.uuid).then(
            function (response) {
                if (response.status === 200) {
                    $state.reload();
                } else {
                    withdrawError();
                }
            }, function () {
                withdrawError();
            }
        );
    }

    $scope.buildScroll = function () {
        $timeout(function () {
            scrollbarHorizontalMenu('.activitylist .scroll');
        }, 1);
    }

    function scrollbarHorizontalMenu(el) {
        $(el).mCustomScrollbar({
            axis: "x",
            theme: "dark-thin",
            autoHideScrollbar: true,
            scrollbarPosition: "outside",
            advanced: {autoExpandHorizontalScroll: true},
            callbacks: {
                onInit: function () {

                },
                onScroll: function () {

                }
            }
        });
    }
}]);
